module.exports = __webpack_public_path__ + "img/kickDrumHit.abb16252.svg";